(function () {
  var LISAMAKSU = 20;
  var ESTA_VIIKONLOPUT = false; // true = la ja su eivät ole valittavissa
  var VARIT = { 'hp-green':'#c8f0c0', 'hp-yellow':'#fff1a0', 'hp-red':'#ffc9c9' };
  var SELECTOR = 'input[name*="paivamaara"]:not([data-hp-init]), .hp-toimituspaiva input:not([data-hp-init]), input.hp-toimituspaiva:not([data-hp-init])';

  // Toimii vain tarjouspyyntösivulla
  if (location.pathname.indexOf('/pages/tarjouspyynto') !== 0) return;

  var css =
    '.flatpickr-calendar .flatpickr-day.hp-green{background:#c8f0c0!important;border-color:#c8f0c0!important;color:#393939!important}' +
    '.flatpickr-calendar .flatpickr-day.hp-yellow{background:#fff1a0!important;border-color:#fff1a0!important;color:#393939!important}' +
    '.flatpickr-calendar .flatpickr-day.hp-red{background:#ffc9c9!important;border-color:#ffc9c9!important;color:#a30000!important}' +
    '.flatpickr-calendar .flatpickr-day.prevMonthDay,.flatpickr-calendar .flatpickr-day.nextMonthDay{opacity:.6}' +
    '.flatpickr-calendar .flatpickr-day:hover{filter:brightness(.92)}' +
    '.flatpickr-calendar .flatpickr-day.selected{background:#3d4246!important;border-color:#3d4246!important;color:#fff!important;opacity:1}' +
    '.flatpickr-calendar .flatpickr-day.flatpickr-disabled{opacity:.3}' +
    '.hp-box{padding:8px 10px;font-size:12px;line-height:1.5;text-align:left;border-top:1px solid #eee}' +
    '.hp-box i{display:inline-block;width:10px;height:10px;border-radius:2px;margin-right:4px}' +
    '.hp-note{margin-top:6px;padding:6px 8px;border-radius:4px;display:none}';

  var ladattu = null;
  function lataaFlatpickr() {
    if (ladattu) return ladattu;
    ladattu = new Promise(function (ok) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = 'https://cdn.jsdelivr.net/npm/flatpickr@4.6.13/dist/flatpickr.min.css';
      document.head.appendChild(l);

      var s = document.createElement('style');
      s.textContent = css;
      document.head.appendChild(s);

      var a = document.createElement('script');
      a.src = 'https://cdn.jsdelivr.net/npm/flatpickr@4.6.13/dist/flatpickr.min.js';
      a.onload = function () {
        var b = document.createElement('script');
        b.src = 'https://cdn.jsdelivr.net/npm/flatpickr@4.6.13/dist/l10n/fi.js';
        b.onload = ok;
        b.onerror = ok;
        document.head.appendChild(b);
      };
      document.head.appendChild(a);
    });
    return ladattu;
  }

  function vari(d) {
    var w = d.getDay(); // 0=su ... 6=la
    if (w === 0 || w === 6) return 'hp-red';
    if (w === 2 || w === 4) return 'hp-green';
    return 'hp-yellow';
  }

  // Sovelluksen lomake on React-pohjainen, joten arvo asetetaan niin, että lomake huomaa muutoksen
  function asetaArvo(el, v) {
    var setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setter.call(el, v);
    el.dispatchEvent(new Event('input',  { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function init(input) {
    input.dataset.hpInit = '1';
    input.type = 'text'; // estää selaimen oman kalenterin
    input.setAttribute('readonly', 'readonly');
    input.placeholder = 'Valitse toimituspäivä';

    window.flatpickr(input, {
      locale: 'fi',
      dateFormat: 'd.m.Y',
      minDate: 'today',
      disableMobile: true,
      disable: ESTA_VIIKONLOPUT ? [function (d) { return d.getDay() % 6 === 0; }] : [],
      onDayCreate: function (a, b, c, el) {
        el.classList.add(vari(el.dateObj));
      },
      onReady: function (a, b, fp) {
        var box = document.createElement('div');
        box.className = 'hp-box';
        box.innerHTML =
          '<div><i style="background:#c8f0c0"></i>Tiistai & Torstai</div>' +
          '<div><i style="background:#fff1a0"></i>Ma, Ke & Pe – +' + LISAMAKSU + ' €</div>' +
          '<div><i style="background:#ffc9c9"></i>La & Su – ei toimituksia normaalisti</div>' +
          '<div class="hp-note"></div>';
        fp.calendarContainer.appendChild(box);
      },
      onChange: function (sel, str, fp) {
        asetaArvo(input, str);
        var note = fp.calendarContainer.querySelector('.hp-note');
        if (!sel.length) {
          input.style.backgroundColor = '';
          note.style.display = 'none';
          return;
        }
        var v = vari(sel[0]);
        input.style.backgroundColor = VARIT[v];
        note.style.display = 'block';
        note.style.background = VARIT[v];
        note.textContent =
          v === 'hp-yellow' ? 'Tämän päivän toimitus maksaa ' + LISAMAKSU + ' € enemmän.' :
          v === 'hp-red'    ? 'Emme toimita viikonloppuisin paitsi poikkeustapauksissa.' :
                              'Normaali toimitusmaksu.';
      }
    });
  }

  var ajastin = null;
  function scan() {
    clearTimeout(ajastin);
    ajastin = setTimeout(function () {
      var kentat = document.querySelectorAll(SELECTOR);
      if (!kentat.length) return;
      lataaFlatpickr().then(function () {
        kentat.forEach(function (el) {
          if (!el._flatpickr && !el.dataset.hpInit) init(el);
        });
      });
    }, 200);
  }

  function start() {
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    scan();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();